import Vue from 'vue'
import Router from 'vue-router'
import Form from '@/components/Form'
import Complete from '@/components/Complete'
import PageNotFound from '@/components/PageNotFound'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'form',
      component: Form
    },
    {
      path: '/complete',
      name: 'complete',
      component: Complete
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js